// extracted by mini-css-extract-plugin
export default {"radiusSlider":"progresSlider_radiusSlider__kAP5c","label":"progresSlider_label__LG771"};